import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = ['en', 'fr', 'de', 'da'];

export function useLang(): string {
  const { i18n } = useTranslation();
  const location = useLocation();
  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  const lang =
    firstSegment && SUPPORTED_LANGS.includes(firstSegment) ? firstSegment : 'en';

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return lang;
}